var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSupplier = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72269 5.07143C9.72269 4.47969 9.27122 4 8.71429 4H4.0084C3.45147 4 3 4.47969 3 5.07143V22.9286C3 23.5203 3.45147 24 4.0084 24H23.5042C24.0611 24 24.5126 23.5203 24.5126 22.9286V10.787C24.5126 9.9425 23.6332 9.42991 22.9628 9.88308L17.1176 13.8352V10.787C17.1176 9.94254 16.2382 9.42991 15.5679 9.88308L9.72269 13.8352V5.07143ZM16.1176 15.7185V10.787C16.1176 10.7528 16.1096 10.7359 16.1054 10.7286C16.1051 10.7282 16.1049 10.7277 16.1046 10.7273L8.72269 15.7185V5.07143C8.72269 5.03322 8.70908 5.0102 8.6999 5H4.02279C4.01361 5.0102 4 5.03322 4 5.07143V22.9286C4 22.9668 4.01361 22.9898 4.02279 23H23.4898C23.499 22.9898 23.5126 22.9668 23.5126 22.9286V10.787C23.5126 10.7528 23.5045 10.7358 23.5003 10.7286C23.5001 10.7282 23.4998 10.7277 23.4996 10.7273L16.1176 15.7185Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSupplier, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/supplier.902cd199.svg";
export { ForwardRef as ReactComponent };